import { Button, Icon, Intent, Popover, Position } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import React from 'react'
import UprightDateRangePicker from '../../UprightDateRangePicker'

const DateRangeFilter = ({ meta, onMetaChange, metaKey, dateRangeProps = {} }) => {
  const v = meta[metaKey]
  const start = v && v[0]
  const end = v && v[1]
  return (
    <div className="bp3-button-group home-created-at-filter">
      <Popover
        position={Position.BOTTOM}
        onClose={() => {
          // clear out date if no valid range selected
          if (!end) onMetaChange(metaKey, null, false)
        }}
      >
        <Button icon={IconNames.CALENDAR} intent={start && end && Intent.PRIMARY}>
          <Icon icon={IconNames.CARET_DOWN} />
        </Button>

        <div className="popover-content">
          <UprightDateRangePicker
            onChange={e => {
              const shouldUpdate = e[0] && !e[1]
              const val = e[0] ? e : null
              onMetaChange(metaKey, shouldUpdate ? e : val, !shouldUpdate)
            }}
            value={[start ? new Date(start) : null, end ? new Date(end) : null]}
            {...dateRangeProps}
          />
        </div>
      </Popover>
    </div>
  )
}

export default DateRangeFilter
